
export const RENDER_FORMAT = {
    Text : 0, // text as generated from items and edited from textbox
    RichTextHtml : 1 //html edited by rich test editor
    // RawHtml : 2, // rawhtml as generated from templates and items
    // ParsedHtml : 3, // react components based on rawhtml
  }

 /**
  * Http header content type
  */ 
export const CONTENT_TYPE = {
    TEXT : 'Text',
    HTML : 'HTML'
}


export const PIVOT_KEY = {
  TEAMS : 'Text',
  CHATS : 'Chats',
  ITEMS : 'Items',
  EDIT : 'Edit',
  SHARE : 'Share',
  SETTINGS : 'Settings',
  ACCOUNT : 'Account'
}

export const READER = {
  TERMS : 'https://www.cohorts.app/reader/terms',
  PRIVACY : 'https://www.cohorts.app/reader/privacy',
  COOKIE : 'https://www.cohorts.app/reader/terms',
  SUPPORT : 'https://www.cohorts.app/reader/support',
  BLOG :  'https://www.cohorts.app/reader/blog',
  USER_GUIDE : 'https://www.cohorts.app/reader/userguide',
  ABOUT :  'https://www.cohorts.app/reader/about'
}


export const LOG_LEVEL = {
  TRACE : 'TRACE',
  DEBUG : 'DEBUG',
  INFO : 'INFO',
  WARN : 'WARN',
  ERROR : 'ERROR',
  SILENT : 'SILENT'
}